import styled, { css } from 'styled-components'

const cellCSS = css<{ width?: string }>`
  border-bottom: ${({ theme }) => theme.borderStyles.table};

  &.collapse {
    width: 0.0000000001%;
  }

  ${({ width }) =>
    width &&
    `
    width: ${width};
    max-width: ${width};
    `}
`

export const Table = styled.table`
  border-spacing: 0;
  border-collapse: separate;
  width: 100%;
  font-size: 14px;
`
export const THead = styled.thead`
  background: ${({ theme }) => theme.colors.light};
`
export const TBody = styled.tbody``
export const Tr = styled.tr<{ hasError?: boolean; isSelected?: boolean }>`
  height: 48px;

  :focus-within {
    background: ${({ theme }) => theme.colors.light};
  }

  :hover {
    background: ${({ theme }) => theme.colors.light};
  }

  ${({ isSelected, theme }) =>
    isSelected && `background: ${theme.colors.light};`}

  ${({ hasError, theme }) =>
    hasError && `background: ${theme.colors.backgroundLaneError};`}
`
export const Th = styled.th.withConfig({
  shouldForwardProp: (prop: PropertyKey) => 'width' !== prop,
})`
  color: ${({ theme }) => theme.colors.backgroundSecondary};
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  padding: 10px 5px;
  text-transform: uppercase;

  ${cellCSS}
`
export const Td = styled.td.withConfig({
  shouldForwardProp: (prop: PropertyKey) => 'width' !== prop,
})`
  padding: 5px;

  ${cellCSS}
`
